<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
const STORE_MODULE_NAME = 'RubricSettingWrapper';

export default {
  name: 'RubricSettingWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
